export default __webpack_public_path__ + "static/media/amanita5.b89d898a.png";